import { aosInstance, instance } from '@/api/instances'

import { surgeryApiResponseToModel, surgeryModelToAPI } from './mapper'

const getProviderUnits = async (store, searchTerm) => {
  try {
    const response = await aosInstance.get('v2/provider_units', {
      params: {
        filter: JSON.stringify({
          q: searchTerm,
          type: 'HOSPITAL,MATERNITY,HOSPITAL_CHILDREN'
        })
      }
    })

    return response
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'surgery/getProviderUnits' },
      { root: true }
    )

    return []
  }
}

const update = async (store, { surgeryId, data, personId }) => {
  try {
    const payload = surgeryModelToAPI(data)

    await instance.put(`persons/${personId}/surgery_attendances/${surgeryId}`, {
      json: payload
    })

    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'surgery/update' },
      { root: true }
    )

    return false
  }
}

const create = async (store, { personId, data }) => {
  try {
    const payload = surgeryModelToAPI(data)

    await instance.post(`persons/${personId}/surgery_attendances`, {
      json: payload
    })

    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'surgery/create' },
      { root: true }
    )

    return false
  }
}

const fetchData = async (store, { surgeryId, personId }) => {
  store.commit('errors/setCriticalError', null, { root: true })

  try {
    const response = await instance.get(
      `persons/${personId}/surgery_attendances/${surgeryId}`
    )

    const model = surgeryApiResponseToModel(response)
    return model
  } catch (error) {
    store.commit(
      'errors/setCriticalError',
      {
        type: 'server',
        context: 'surgery'
      },
      { root: true }
    )

    return null
  }
}

export default {
  create,
  fetchData,
  update,
  getProviderUnits
}
